import { render } from "./ChevronLeft.vue?vue&type=template&id=b1e34b56"
const script = {}

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__